import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AccountsService } from '@services/accounts.service';
import { AuthenticateAdminService } from '@services/dws/authenticate-admin.service';

@Injectable({ providedIn: 'root' })
export class WsSuperadminService {
  readonly isSuperadmin$: Observable<boolean> = combineLatest([
    this.accountsService.authorization$,
    this.authenticateAdminService.authorization$,
  ]).pipe(
    map(([auth, adminAuth]) => !!(auth?.is_admin || adminAuth?.is_admin))
  );

  constructor(
    private accountsService: AccountsService,
    private authenticateAdminService: AuthenticateAdminService
  ) {}

  isSuperadmin(): boolean {
    let isSuperadmin = false;

    this.accountsService.authorization$.pipe(take(1)).subscribe((authorization) => {
      if (authorization?.is_admin) {
        isSuperadmin = true;
      }
    });

    this.authenticateAdminService.authorization$.pipe(take(1)).subscribe((authorization) => {
      if (authorization?.is_admin) {
        isSuperadmin = true;
      }
    });

    return isSuperadmin;
  }
}
